//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { renderContentCount } from '@motionelements/core/src/helpers/contentCount.js';

/** Fixed totals so default (en) short format stays 90k / 25m / 1.4m; `renderContentCount` still localizes (e.g. 万). */
const HERO_STAT_TITLE_COUNTS = [90000, 25000000, 1400000];

export default {
  name: 'SubscribeHero2026Stats',
  props: {
    items: {
      type: Array,
      default: undefined,
    },
  },
  computed: {
    displayItems() {
      if (this.items && this.items.length) {
        return this.items;
      }
      const mediaShort = (key) => this.$term('mediaType', key).plural().short().text();
      const title = (i) => renderContentCount(this, HERO_STAT_TITLE_COUNTS[i], 1, true);
      return [
        {
          title: title(0),
          descriptionLines: [
            `${mediaShort('ae')}, ${mediaShort('pr')}, ${mediaShort('resolve')},`,
            this.$t('phrase.motion_templates'),
          ],
        },
        {
          title: title(1),
          descriptionLines: [
            `${mediaShort('video')}, ${mediaShort('image')},`,
            mediaShort('vector'),
          ],
        },
        {
          title: title(2),
          descriptionLines: [
            `${mediaShort('music')}, ${this.$t('phrase.sound_effects')}`,
          ],
        },
      ];
    },
  },
};
